/*
 * Stock status cut-off countdown (Wavetrac, 2026-10-22).
 * <stock-cutoff data-cutoff="15:00" data-days="1,2,3,4,5," data-holidays="2026-12-25, 2026-12-26">
 * Works in UK time (Europe/London, so BST/GMT is handled). Before the cut-off on a shipping day it
 * shows [data-before] with a live countdown in [data-timer]; otherwise it shows [data-after].
 * The element is re-created whenever the theme re-renders the block on a variant change, so the
 * timer starts and stops with the element (connected/disconnected callbacks).
 */
(function () {
  if (customElements.get('stock-cutoff')) return;

  var fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short', hourCycle: 'h23'
  });
  var DAY = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

  function londonNow() {
    var p = {};
    fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return {
      date: p.year + '-' + p.month + '-' + p.day,
      weekday: DAY[p.weekday],
      secs: (+p.hour) * 3600 + (+p.minute) * 60 + (+p.second)
    };
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  class StockCutoff extends HTMLElement {
    connectedCallback() {
      var m = /^(\d{1,2}):(\d{2})$/.exec((this.dataset.cutoff || '').trim());
      this.cutoff = m ? (+m[1]) * 3600 + (+m[2]) * 60 : null;
      this.days = (this.dataset.days || '').split(',').filter(Boolean).map(Number);
      this.holidays = (this.dataset.holidays || '').split(/[\s,]+/).filter(Boolean);
      this.before = this.querySelector('[data-before]');
      this.after = this.querySelector('[data-after]');
      this.timer = this.querySelector('[data-timer]');
      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      var now = londonNow();
      var shipsToday = this.cutoff !== null &&
        this.days.indexOf(now.weekday) !== -1 &&
        this.holidays.indexOf(now.date) === -1 &&
        now.secs < this.cutoff;
      if (shipsToday) {
        var left = this.cutoff - now.secs;
        var h = Math.floor(left / 3600), mi = Math.floor((left % 3600) / 60), s = left % 60;
        var text = (h ? h + 'h ' : '') + pad(mi) + 'm ' + pad(s) + 's';
        if (this.timer && this.timer.textContent !== text) this.timer.textContent = text;
      }
      if (this.before && this.before.hidden === shipsToday) this.before.hidden = !shipsToday;
      if (this.after && this.after.hidden !== shipsToday) this.after.hidden = shipsToday;
    }
  }

  customElements.define('stock-cutoff', StockCutoff);
})();
